<template>
  <v-app-bar app flat clipped-left dark :color="colorAppBar">
    <v-toolbar-title class="mr-4">
      <img
        v-if="showAffiliationLogo"
        :class="$style.logo"
        src="../../assets/images/logo-company.png"
        alt="Logo"
      />
    </v-toolbar-title>
    <v-toolbar-items></v-toolbar-items>
    <v-spacer></v-spacer>

    <locale-change />

    <theme-change />

    <v-toolbar-items>
      <v-btn text @click="handleLogout" v-if="isAuthorized()">{{ $t('common.logout') }}</v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import ThemeChange from '@/components/common/ThemeChange.vue';
import LocaleChange from '@/components/common/LocaleChange.vue';
import { AuthMixin } from '@lib/vue-playrix-auth/mixins';

import { NOT_AUTHORIZED } from '@/config/events';
import { HIDE_AFFILIATION } from '@/config/features';

export default {
  components: {
    ThemeChange,
    LocaleChange,
  },
  mixins: [AuthMixin],
  computed: {
    colorAppBar() {
      return this.$vuetify.theme.dark ? 'borderDocuments' : 'primary';
    },
    showAffiliationLogo() {
      return !HIDE_AFFILIATION;
    },
  },
  methods: {
    handleLogout() {
      this.$eventHub.$emit(NOT_AUTHORIZED);
    },
  },
};
</script>

<style lang="scss" module>
.logo {
  max-width: 120px;
  max-height: 40px;
  margin-top: 5px;

  @media screen and (max-width: 400px) {
    max-width: 100px;
  }
}
</style>
